
import Photo from "../resources/MyPhoto.jpg";
import { FaLinkedin } from "react-icons/fa";

const AboutCard = () => {

    return (
        <div className="w-full lg:w-1/2 rounded-xl flex justify-around items-center gap-2 px-2 m-6">
            <div>
                <img
                    src={Photo}
                    alt=""
                    className="relative aspect-square object-cover rounded-xl h-[clamp(120px,40vh,300px)]"
                />
                <div className="text-text h-full justify-evenly w-fit flex flex-col text-[clamp(1rem,1vw+0.5rem,1.5rem)]">
                    <span className="flex gap-2 items-center">
                        <h1 className="font-bold text-text lg:text-2xl text-xl">
                            Dr Phil Juricev
                        </h1>
                        <a href="https://www.linkedin.com/in/philjuricev/" target="_blank" rel="noopener noreferrer"><FaLinkedin className="w-8 h-8 hover:text-accent" /></a>
                    </span>
                    <ul className="h-full flex flex-col justify-evenly gap-y-4">
                        <li className="flex items-center">
                            <svg className="w-6 h-6 me-2 text-green-400 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg> Statistical modelling
                        </li>
                        <li className="flex items-center">
                            <svg className="w-6 h-6 me-2 text-green-400 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg> Geospatial systems
                        </li>
                        <li className="flex items-center">
                            <svg className="w-6 h-6 me-2 text-green-400 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg> Process optimisation
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    );
};



export default AboutCard;